module.exports = __webpack_public_path__ + "img/sip_login.9e2a9157.png";